import React, { Component, createRef } from 'react';
import {
  Button,
  FormGroup,
  Col, 
  Container,
  Input,
  Row
} from 'reactstrap';
import ApiCall from '../../../services/ApiCall'
import { showSwalLoading } from '../../../services/Helper'
import swal from 'sweetalert2'
import jwt from 'jsonwebtoken'
import './Login.css'
import ReCAPTCHA from 'react-google-recaptcha'
import PKCEHelper from '../../../services/PKCEHelper'
import { DUENDE_CONFIG } from '../../../constants'
import DuendeTokenManager from '../../../services/DuendeTokenManager'

class Login extends Component {

  constructor() {
    super()
    this.reRef = createRef()
  }

  state = {
    username: '',
    password: '',
    loading: true,
    ssoLoading: false
  }

  style = {
    backgroundImage: 'linear-gradient(#9675ce,#9675ce),linear-gradient(rgba(120,130,140,.13),rgba(120,130,140,.13))',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backgroundPosition: 'center bottom,center calc(99%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '0 2px,100% 1px',
    padding: 0
  }

  componentWillMount() {
    // Check legacy token
    let token = localStorage.getItem('token')
    if (token != null) {
      let userData = jwt.decode(token)
      if (userData) {
        let user = userData.user
        if (user) {
          window.location = '/astra/#/home'
        }
      }
    }
    
    // Check Duende SSO token
    if (DuendeTokenManager.hasValidTokens()) {
      window.location = '/astra/#/home'
    }
  }

  componentDidMount() {
    this.setState({loading:false})

    // Show SSO notifications if present
    try {
      const ssoError = sessionStorage.getItem('duende_sso_error')
      if (ssoError) {
        swal('SSO Login Gagal', ssoError, 'error')
        sessionStorage.removeItem('duende_sso_error')
      }
      const ssoSuccess = sessionStorage.getItem('duende_sso_success')
      if (ssoSuccess) {
        swal('SSO Login Berhasil', 'Selamat datang ' + ssoSuccess, 'success')
        sessionStorage.removeItem('duende_sso_success')
      }
      const logoutSuccess = sessionStorage.getItem('duende_logout_success')
      if (logoutSuccess) {
        swal('Logout Berhasil', 'Anda telah berhasil logout', 'success')
        sessionStorage.removeItem('duende_logout_success')
      }
    } catch(e) {}
  }

  toAfc() {
    window.location.href=`${process.env.SWITCH_TO_AFC || 'https://afction.astra.co.id'}`
  }

  /**
   * Initiate SSO login flow directly
   */
  async handleSSOLogin() {
    try {
      this.setState({ ssoLoading: true });

      // Generate PKCE parameters
      const pkceData = await PKCEHelper.generatePKCE();
      
      // Store PKCE data in sessionStorage for callback
      PKCEHelper.storePKCE(pkceData);

      // Build authorization URL
      const authUrl = new URL(`${DUENDE_CONFIG.BASE_URL}/connect/authorize`);
      authUrl.searchParams.append('client_id', DUENDE_CONFIG.CLIENT_ID);
      authUrl.searchParams.append('redirect_uri', DUENDE_CONFIG.REDIRECT_URI);
      authUrl.searchParams.append('response_type', DUENDE_CONFIG.RESPONSE_TYPE);
      authUrl.searchParams.append('scope', DUENDE_CONFIG.SCOPE);
      authUrl.searchParams.append('code_challenge', pkceData.codeChallenge);
      authUrl.searchParams.append('code_challenge_method', pkceData.codeChallengeMethod);
      authUrl.searchParams.append('state', pkceData.state);

      // Debug logging
      console.log('=== SSO Configuration Debug ===');
      console.log('Client ID:', DUENDE_CONFIG.CLIENT_ID);
      console.log('Redirect URI:', DUENDE_CONFIG.REDIRECT_URI);
      console.log('Scope:', DUENDE_CONFIG.SCOPE);
      console.log('Authorization URL:', authUrl.toString());
      console.log('===============================');

      // Redirect to Duende authorization
      window.location.href = authUrl.toString();
    } catch (error) {
      console.error('Error initiating SSO login:', error);
      this.setState({ ssoLoading: false });
      swal('Error', 'Failed to initiate SSO login. Please try again.', 'error');
    }
  }

  async login (e) {
    e.preventDefault()
    let { username, password } = this.state

    const tokenCaptcha = await this.reRef.current.executeAsync();
    this.reRef.current.reset()
    
    showSwalLoading()
    try {
      const res = await ApiCall.login({ username, password, tokenCaptcha })
      swal.close()
      this.props.history.push('/login/verify-otp')
      let email = res.data.email
      localStorage.setItem('email', email)
    } catch (error) {
      swal.close()
      if (error.response) {
        swal('Oops...', error.response.data.message, 'error').then((result) => {
          let { username } = this.state 
          window.location.reload().then((result) => {
            this.setState({username})
          })
        })
      } else {
          swal('Oops...', 'Something went wrong! Check internet connection!', 'error').then((result) => {
            window.location.reload()
          })
          console.error('error message: ', error)
      }
    }
  }


  render() {
    let {username, password, loading} = this.state
    if (loading) return (<div></div>)
    return (
      <div className="app flex-row align-items-center background-home">
        <Container>
          <div className="card-form-login"> 
            
              <div className='text-center logo'>
                G R E E N
                  <img src={'/assets/img/brand/logo-agc.png'} className="" alt="logo astra green company" />                             
                C O M P A N Y
              </div>

              <p className="text-uppercase text-semibold m-b-15">Sign In</p>

              <Row>
                <Col xs="12">
                  <Button 
                    className="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light" 
                    onClick={() => this.handleSSOLogin()}
                    type="button"
                    disabled={this.state.ssoLoading}
                  >
                    {this.state.ssoLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        REDIRECTING...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-sign-in mr-2"></i>
                        SIGN IN WITH SSO
                      </>
                    )}
                  </Button>
                </Col>
                <Col xs="12" style={{paddingTop: 20}}>
                  <Button className="btn btn-success btn-lg btn-loading btn-block text-uppercase waves-effect waves-light" onClick={this.toAfc}>SWITCH TO AFC</Button>
                </Col>
              </Row>

          </div>
        </Container>
      </div>
    );
  }
}

export default Login;
